import { useMeContext } from './useMeContext';

export const useSubstituteUserMetadata = () => {
  const { substituteUserMetadata } = useMeContext();

  return substituteUserMetadata;
};
